
import React from 'react';
import StudentCornor from 'views/LanguageAssociation';

const StudentCornorPage = () => {
  return <StudentCornor />;
};

export default StudentCornorPage;